import React from 'react'
import {getTimeSinceUTCDate} from "../../../common/timestamp";

function TimeSince(props) {
  return (
    <span className="timestamp">
      {getTimeSince(props.timestamp)}
    </span>
  );
}

function getTimeSince(timestamp) {

  timestamp = formatTimestamp(timestamp);

  const utc_timestamp = XDate(timestamp);
  return getTimeSinceUTCDate(utc_timestamp);
}

function formatTimestamp(timestamp) {
  /*  Timestamps from the api aren't valid ISO so we need to format them.
      They look like this: 20161219T205151
      They need to look like this: 2016-12-19T20:51:51Z */

  timestamp = insertAt(15, "Z", timestamp);
  timestamp = insertAt(13, ":", timestamp);
  timestamp = insertAt(11, ":", timestamp);
  timestamp = insertAt(6, "-", timestamp);
  timestamp = insertAt(4, "-", timestamp);

  return timestamp;
}

function insertAt(position, val, str) {
  return str.substr(0, position) + val + str.substr(position);
}

export default TimeSince;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/time-since.es6